@if (type === 'overlay') {
  <div class="toolbox-overlay">
    <div [ngClass]='["background", type]'></div>
    <mat-card [ngClass]='["toolbox", type, "image-toolbox",
                          displayTitle ? "w-title" : "wo-title"]'>
      <mat-card-header>
        @if (displayTitle) {
          <mat-card-title>
            {{ 'i18n.toolbox.image.title' | translate }}
          </mat-card-title>
        }
        <mat-icon svgIcon="close"
          class="close-x"
        (click)="btnCancelClick()"></mat-icon>
      </mat-card-header>
      <mat-card-content [ngClass]='["image-cropper-container"]'>
        <image-cropper
          [targetRegion]="imageDimensions"
          [imageUrl]="imageUrl"
          [(selectedRegion)]="crop"
          [editableArea]="editableArea"
          (selectedRegionChange)="updateBoundingBox()"
          [maskPath] = "'M 0 0 h 10 v10 h -10 v -10'"
          [availableHeight]="imageCropperMaxHeight"
        ></image-cropper>
        <div class="spacer"></div>
        <div class="image-zoom">
          <image-zoom [(selectedRegion)]="crop"
            [targetRegion]="imageDimensions"
            (selectedRegionChange)="updateBoundingBox()"
          ></image-zoom>
        </div>
        <div class="image-quality-rating">
          <image-quality-rating #imageQualityRating [domImageId]="domImageId"
          ></image-quality-rating>
        </div>
      </mat-card-content>
      <mat-card-actions [ngClass]='["buttons"]'>
        <button mat-raised-button (click)="btnCancelClick()"
          size="small"
          translate class="cancel">
          i18n.button.cancel
        </button>
        <button mat-raised-button color="primary" (click)="btnOKClick()"
          size="small"
          translate>
          i18n.button.apply
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
}
